import script from "./infoSection.vue?vue&type=script&setup=true&lang=js"
export * from "./infoSection.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__